import moment from 'moment';

const yesterday = moment().subtract(1, 'day');
type DateFilter = 'yesterday';

/**
 * isValidDate returns which values are valid to be selected
 * @param current - current date
 * @param dateFilter - given date filter declared from
 */
export const isValidDate = function(current: any, dateFilter?: DateFilter) {
	switch (dateFilter) {
		case 'yesterday':
			return current.isAfter(yesterday);
		default:
			return true;
	}
};
